import { render, staticRenderFns } from "./creditByBusR.vue?vue&type=template&id=85461b68&scoped=true&"
import script from "./creditByBusR.vue?vue&type=script&lang=js&"
export * from "./creditByBusR.vue?vue&type=script&lang=js&"
import style0 from "./creditByBusR.vue?vue&type=style&index=0&id=85461b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85461b68",
  null
  
)

export default component.exports